import { render, staticRenderFns } from "./PluginsSummary.vue?vue&type=template&id=6db907ce&scoped=true&"
import script from "./PluginsSummary.vue?vue&type=script&lang=js&"
export * from "./PluginsSummary.vue?vue&type=script&lang=js&"
import style0 from "./PluginsSummary.vue?vue&type=style&index=0&id=6db907ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db907ce",
  null
  
)

export default component.exports